import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Aegis admin module — `/aegis` on console.francisquini.ai.
 *
 * Dashboard 1.3 (Tier 1) — observability for the Cuidari app: error
 * events, decision/release/surface aggregates, crash rates per release.
 * Spec: `docs/cockpit/dashboards/tier-1-operacional-critico.md §1.3`.
 *
 * Surface is `'admin'` — registered only on the console host. Each page
 * also wraps `<RequireAdmin>` for defence-in-depth.
 */
export const manifest: ModuleManifest = {
  module_id: 'aegis',
  display_name: 'Aegis',
  surface: 'admin',
  routes: [
    {
      path: '/aegis',
      component: () =>
        import('@/modules/aegis').then((m) => ({ default: m.AegisHomePage })),
      title: 'Aegis — Dashboard',
      permissions: [],
    },
    {
      path: '/aegis/errors',
      component: () =>
        import('@/modules/aegis').then((m) => ({ default: m.AegisErrorsPage })),
      title: 'Aegis — Erros',
      permissions: [],
    },
    {
      path: '/aegis/errors/$eventId',
      component: () =>
        import('@/modules/aegis').then((m) => ({
          default: m.AegisErrorDetailPage,
        })),
      title: 'Aegis — Detalhe do erro',
      permissions: [],
    },
    {
      path: '/aegis/releases',
      component: () =>
        import('@/modules/aegis').then((m) => ({
          default: m.AegisReleasesPage,
        })),
      title: 'Aegis — Releases',
      permissions: [],
    },
    {
      path: '/aegis/decisions/$decisionId',
      component: () =>
        import('@/modules/aegis').then((m) => ({
          default: m.AegisDecisionRedirectPage,
        })),
      title: 'Aegis — Decisão Phronesis',
      permissions: [],
    },
  ],
}
